<div class="loading-state">
  <mat-spinner diameter="30" />
</div>
